import ClienteController from "@/shared/controllers/cliente/clienteController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import EVENTS from "@/shared/events/events";
import FiltroConsultarOrcamento from "@/shared/view-models/Filtros/FiltroConsultarOrcamento";
import { defineComponent } from "vue";

const name = 'ConsultarOrcamentoPendente'
export default defineComponent({
  name,

  components: { },

  props: { },

  mounted () {
    // this.clienteArray = ClienteController.getClientesAtivos().ClientesArray;
    this.empresaArray = this.$store.state.EmpresaArray;
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId
      this.objFiltro.EmpresaId = this.$store.state.empresaSelecionadaId
    });
    this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId;
        
    let urlParams = new URLSearchParams(window.location.search)

    if(urlParams.get('FlagDashboard') !== null){
      // this.objFiltro.EmpresaId = this.$store.state.empresaSelecionadaId;
      this.getOrcamentosByFiltro()
    }
  },

  updated () { },

  data () {
    return {
        linhaSelecionada: {},
        popup: false,
        informacaoOrcamentoSelecionado:null,
        popupMotivo: false,
        orcamentoArray: [],
        empresaArray: [],
        clienteArray: [],
        LinhaProducaoArray: [],
        LinhaProducao: '',
        CidadeSelecionada: '',
        motivoRetorno: '',
        pt1: true,
        habilitarbotao: false,
        ProdutoArray: [],
        numeroOrcamento: null,
        objFiltro: new FiltroConsultarOrcamento(),
        Colunas : [
          //Campo dos dados , nome que aparece na página
          {field: 'numeroOrcamento', header: 'N° Solicitação', width: '160px', ordena: true},
          {field: 'dataDigitacaoFormatadaText', header: 'Dt. Digitação', width: '160px', ordena: true, ordenacao: 'dataDigitacao'},
          {field: 'dataValidadeFormatadaText', header: 'Dt. Retorno', width: '160px', ordena: true, ordenacao: 'dataValidade'},
          {field: 'nomeProduto', header: 'Nome Produto', width: '300px', ordena: true},
          // {field: 'orcamentoSincronismoEnum', header: 'Status'},
          {field: 'tipoText', header: 'Tipo', width: '260px', ordena: true},
          {field: 'empresaRepresentanteCliente', header: 'Empresa Representante Cliente', width: '250px', ordena: true}
        ],
        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'codigoUsuario': {value: null, matchMode: this.filtros.CONTAINS},
          'razaoSocial': {value: null, matchMode: this.filtros.CONTAINS},
          'segmentoFormat': {value: null, matchMode: this.filtros.CONTAINS},
          'estadoCidade': {value: null, matchMode: this.filtros.CONTAINS},
          'numeroTelefone': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeContato': {value: null, matchMode: this.filtros.CONTAINS},
          'clienteSituacaoEnum': {value: null, matchMode: this.filtros.CONTAINS},
          'CV': {value: null, matchMode:this.filtros.CONTAINS},
        },
        timer: null,
    }
  },

  methods: {
    

  continuarOrca(data){

    let OrcamentoId = data.id
    let tipoFluxoOrcamento = data.tipoFluxoOrcamento

    switch(tipoFluxoOrcamento){
      case 0:
        this.$router.push(`/produto-novo/${OrcamentoId}/infos-cliente`)
      break
      case 1:
          this.$router.push(`/produto-repeticao/${OrcamentoId}/Informacao-Cliente-Repeticao`)
      break
      case 2:
        this.$router.push(`/produto-repeticao-alteracao/${OrcamentoId}/info-cliente-ra`)
      break
    }
  },

    redireciona(){
        this.continuarOrca(this.informacaoOrcamentoSelecionado)

    },

    GerarOrcaClick(data){
        this.motivoRetorno = data.motivoRetorno;
        this.popupMotivo = true;
        this.informacaoOrcamentoSelecionado= data
        this.numeroOrcamento = data.numeroOrcamento
    },
    getOrcamentosByFiltro(){
      this.$isLoading(true)
      OrcamentoController.getOrcamentosPendentesByFiltro(this.objFiltro).requisicao
      .then(res => {
        this.pt1 = false;
        this.orcamentoArray = res.data.data ? res.data.data : []
      })
      .finally(() => this.$isLoading(false))
    },

    copiarPopUp(linhaSelecionada){
      this.linhaSelecionada = linhaSelecionada
      this.popup = true;
    },

    criarCopiaDeOrcamento(){
      let tipoFluxoOrcamento = this.linhaSelecionada.tipoFluxoOrcamento

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Orcamento/InsertNovoOrcamentoCopia/${this.linhaSelecionada.id}`
      })
        .then((response) => {
         this.OrcamentoId = response.data.data

         switch(tipoFluxoOrcamento){
          case 0:
          this.$router.push(`/produto-novo/${this.OrcamentoId}/infos-cliente`)
          break

          case 1:
          this.$router.push(`/produto-repeticao/${this.OrcamentoId}/Informacao-Cliente-Repeticao`)
          break

          case 2:
          this.$router.push(`/produto-repeticao-alteracao/${this.OrcamentoId}/info-cliente-ra`)
          break
         }}
         )
    },

    limparFiltro(){
      this.objFiltro = new FiltroConsultarOrcamento();
      this.orcamentoArray = []
    },
    buscarLinhaProducao(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        OrcamentoController.getLinhaProducaoDropDownsByNome(event).requisicao
        .then(response => {
          this.LinhaProducaoArray = response.data.data
        })
      }, 1000);
    },
    buscarClientes(event){

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clienteArray = ClienteController.getClienteDropDownsByNome(event, this.objFiltro.EmpresaId, this.objFiltro.RepresentanteId).ClientesArray;
      }, 1000);
    },
    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.getClienteDropDownsByNome(pesquisa, this.objFiltro.EmpresaId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },
    direcionaDetalhes(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `orcamentos-pendentes-informacao/${data.id}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },


  },

  computed: { },

});